import React from "react";
import { Box } from "@mui/material";
import RequestBacklog from "./RequestBacklog";
import Reporting from "./Reporting";
import ManageThresholds from "./ManageThresholds";
import { GlobalTabCollection, StyledTab } from "../../styles.js";

const ComponentProcurement = ({ ...props }) => {
  const [tabValue, setTabValue] = React.useState(0);
  const [newRequest, setNewRequest] = React.useState(null);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  function handleNewRequest(request){
    setNewRequest(request);
    setTabValue(0);
  }

  const renderSearchTab = () => {
    switch (tabValue) {
      case 0: {
        return <RequestBacklog newRequest={newRequest} setNewRequest={setNewRequest}></RequestBacklog>;
      }
      case 1: {
        return <Reporting handleNewRequest={handleNewRequest}></Reporting>;
      }
      case 2: {
        return <ManageThresholds></ManageThresholds>;
      }
      default: {
        alert(tabValue);
      }
    }
  };

  return (
    <>
      <div>
        <Box sx={{ bgcolor: "#fff" }}>
          <GlobalTabCollection value={tabValue} onChange={handleChange} aria-label='ant example'>
            <StyledTab label='Request Backlog' />
            <StyledTab label='Reporting' />
            <StyledTab label='Manage Thresholds' />
          </GlobalTabCollection>
          <Box sx={{ p: 3 }} />
        </Box>
        {renderSearchTab()}
      </div>
    </>
  );
};

export default ComponentProcurement;